export default {
    setSiteGroupsList(state, value){
        state.siteGroupsList = value;
    },
    setFilteredSiteGroupsList(state, value){
        state.selectedSiteGroupsList = value;
    },
    setFilteredSiteGroupsObjectList(state, value) {
        state.filteredSiteGroupsObjects = value;
    },

    setNetworkList(state, value){
        state.networkList = value;
    },
    setFilteredNetworkList(state, value){
        state.selectedNetworkList = value;
    },
    setFilteredNetworkObjectList(state, value) {
        state.filteredNetworkObjects = value;
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/scrubRateHourlyReport/mutations.js